import { Controller } from "@hotwired/stimulus"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import * as Log from "web-ui/log"

// Connects to data-controller="textarea"
export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    this.debug("Connect")

    this.textareaTarget.addEventListener("focus", this.onFocus)
    this.textareaTarget.addEventListener("blur", this.onBlur)
    this.textareaTarget.addEventListener("input", this.resize)
  }

  disconnect() {
    this.debug("Disconnect")

    this.textareaTarget.removeEventListener("focus", this.onFocus)
    this.textareaTarget.removeEventListener("blur", this.onBlur)
    this.textareaTarget.removeEventListener("input", this.resize)
  }

  resize = () => {
    this.debug("Resizing textarea", { id: this.textareaTarget.id })

    this.element.dataset.text = this.textareaTarget.value
  }

  onFocus = () => {
    morphdomIgnore(this.element, true)
  }

  onBlur = () => {
    morphdomIgnore(this.element, false)
  }

  debug(message, data) {
    Log.debug("Textarea - " + message, data)
  }
}
